import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d02aa720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-between items-center q-pa-sm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-h6 q-my-md" }, "My Tags")
], -1))
const _hoisted_3 = { class: "col-5" }
const _hoisted_4 = { class: "col text-right" }
const _hoisted_5 = {
  key: 0,
  class: "column q-my-xl content-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row text-h6" }, " You have no saved tags. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row caption justify-center" }, " Get started by creating your first tag. ", -1))

import { computed, onMounted, readonly, ref, watch } from "vue";
import { TagService, useTagStore } from "../modules/tag/model/TagService";
import { Tag } from "@/modules/tag/model/Tag";

import { container } from "@/system/container";
import { TOKENS } from "@/system/tokens";

import TagView from "@/modules/tag/components/Tag.vue";
import FilterInput from "@/components/FilterInput.vue";
import ColorInput from "@/modules/tag/components/ColorInput.vue";
import TagDialog from "@/modules/tag/components/TagDialog.vue"
///////////////////////////////////////////////////
//                                               //
//                MEMBERS                        //
//                                               //
///////////////////////////////////////////////////


export default /*#__PURE__*/_defineComponent({
  __name: 'TagPage',
  setup(__props) {

var tag = ref();
var original = ""
const showDialog = ref(false);

const tagFactory = container.get(TOKENS.tagFactory);
const store = useTagStore();


const tags = ref(store.filterTags(""))

watch(showDialog, (value) => {
  if (!value)
    filterTags("")
})


///////////////////////////////////////////////////
//                                               //
//                FUNCTIONS                      //
//                                               //
///////////////////////////////////////////////////

const filterTags = (text: string) => {
  tags.value = store.filterTags(text);
}

const select = (_tag: Tag) => {
  tag.value = _tag;
  original = JSON.stringify(tag.value)
  showDialog.value = true;
}

const newTag = () => {
  tag.value = tagFactory.createDefaultUnsavedTag();
  original = JSON.stringify(tag.value)
  showDialog.value = true;
}


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createVNode(FilterInput, {
          placeholder: "Filter tags",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (filterTags($event)))
        })
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_q_btn, {
          round: "",
          color: "green-5",
          icon: "add",
          onClick: newTag
        })
      ]),
      _createVNode(TagDialog, {
        tag: _unref(tag),
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event))
      }, null, 8, ["tag", "modelValue"])
    ]),
    _createVNode(_component_q_separator, { class: "q-my-md" }),
    _createElementVNode("section", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
        return (_openBlock(), _createBlock(TagView, {
          key: tag.id,
          class: "m-1",
          onSelect: select,
          tag: tag
        }, null, 8, ["tag"]))
      }), 128))
    ]),
    (!tags.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("span", {
            onClick: newTag,
            class: "q-my-sm create-link-text"
          }, " + Create Tag ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})